/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description moreResultReducer
 */

import { combineActions, handleActions } from 'redux-actions'

import {
  GET_LISTABLES_SUCCESS,
  GET_LISTABLES_ERROR,
  HIDE,
  RESET_SAVED_SEARCHES_VIEW,
} from '../constants/index'

const moreResultReducer = handleActions(
  {
    [GET_LISTABLES_SUCCESS]: (state, action) => {
      const { payload } = action
      if (payload) {
        const { listables } = payload
        // continuation search, merge existing listables + new listables
        const listablesSize = listables.listables.length
        const featuredSize = (listables.featured && listables.featured.length) || 0
        const { matching } = listables

        // more result available
        // TODO: does this actually work?! Seems like the listables in a specific
        // page would usually add up to less than the matching?
        return !!(listablesSize || listablesSize + featuredSize < matching)
      }
      return false
    },
    [combineActions(GET_LISTABLES_ERROR, HIDE, RESET_SAVED_SEARCHES_VIEW)]: () => false,
  },
  false // schema had a default of true
)

export default moreResultReducer
